import styled from '@emotion/styled'
import React from 'react'

import { Box, AppBar, Toolbar } from '@mui/material'
import { NavLink } from 'react-router-dom'

import Sparklogo from '../../../assets/sparklogo.svg'
import RecentSearch from '../../Breadcrumbs/RecentSearch'
import ExpanderToggle from '../Components/ExpanderToggle/ExpanderToggle'
import SearchHelpDialog from '../Components/SearchHelpDialog/SearchHelpDialog'
import UserAccountSelect from '../Components/UserSettingsMenu/UserAccountSelect'

import { Organization, useUserProfileOptionsQuery } from '../../../generated/graphql'
import { SearchBar, UserAvatar } from '../Components'

const StyledAppBar = styled(AppBar)`
    background-color: ${({ theme }) => theme.palette.common.white} !important;
`

const AppBarContents = styled.div`
    ${({ theme }) => theme.palette.common.white};
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-right: 12px;
    padding-left: 12px;

    ${({ theme }) => theme.breakpoints.up('md')} {
        padding-right: 24px;
        padding-left: 24px;
    }
`

const RecentToolbar = styled(Toolbar)`
    width: 100%;
    margin-left: ${({ theme }) => theme.spacing(0.5)}px;
`

const MarginDiv = styled.div`
    margin-left: ${({ theme }) => theme.spacing(0.5)}px;
`
type Props = {
    auctionPickerOpenRequest: number
    searchText: string
    setSearchText: React.Dispatch<React.SetStateAction<string>>
}

const DesktopNav: React.FC<Props> = ({ auctionPickerOpenRequest, searchText, setSearchText }) => {
    const editing = false

    const { data } = useUserProfileOptionsQuery()
    const isGlobalAdmin = data?.user?.attributes?.isGlobalAdmin || false

    const organizations = (data?.user?.organizations as Organization[]) || []
    const activeOrganization =
        (data && data.activeOrganization && data.activeOrganization) || ({ orgId: '' } as Organization)

    return (
        <div>
            <StyledAppBar position="fixed">
                <AppBarContents>
                    <ExpanderToggle />
                    <MarginDiv>
                        <NavLink to="/">
                            <img src={Sparklogo} alt="logo" />
                        </NavLink>
                    </MarginDiv>
                    <Toolbar disableGutters>
                        <SearchBar searchText={searchText} setSearchText={setSearchText} disabled={editing} />
                    </Toolbar>
                    <RecentToolbar disableGutters>
                        <SearchHelpDialog />
                        <RecentSearch />
                    </RecentToolbar>
                    <Toolbar disableGutters>
                        <Box>
                            <UserAccountSelect
                                organizations={organizations}
                                activeOrganization={activeOrganization}
                                isGlobalAdmin={isGlobalAdmin}
                                openRequest={auctionPickerOpenRequest}
                            />
                        </Box>
                        <UserAvatar disabled={editing} />
                    </Toolbar>
                </AppBarContents>
            </StyledAppBar>
            {/* Empty Toolbars for spacing: https://material-ui.com/components/app-bar/#fixed-placement */}
            <Toolbar />
        </div>
    )
}

export default DesktopNav
